import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { TranslationModule } from '@lib/translation';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { VaultModule } from '@lib/vault';

import { SnImageEditorComponent } from './components/image-editor/image-editor.component';
import { SnShareImageDialogComponent } from './components/share-image-dialog/share-image-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    SnButtonModule,
    MatButtonModule,
    SnIconModule,
    VaultModule,
    TranslationModule,
  ],
  declarations: [SnImageEditorComponent, SnShareImageDialogComponent],
})
export class UiImageEditorModule {}
